import { Radio, RadioProps } from "@mui/material";

export type SHRadioProps = RadioProps;

export const SHRadio = (props: SHRadioProps): JSX.Element => (
  <Radio {...props} />
);
